module.exports = __webpack_public_path__ + "img/img_level_11.8f3d0cb0.png";